import { render, staticRenderFns } from "./OrgChartDetails.vue?vue&type=template&id=46a5112e&scoped=true"
import script from "./OrgChartDetails.vue?vue&type=script&lang=js"
export * from "./OrgChartDetails.vue?vue&type=script&lang=js"
import style0 from "./OrgChartDetails.vue?vue&type=style&index=0&id=46a5112e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5112e",
  null
  
)

export default component.exports